import { Pipe, PipeTransform } from '@angular/core';
import { PlasterType } from './plaster-type.enum';

@Pipe({
  name: 'plasterType'
})
export class PlasterTypePipe implements PipeTransform {

  transform(value: PlasterType, args?: any): string {
    switch (value) {
      case PlasterType.OdpornyNaGrzyby:{
        if (args == 1) {
          return "Tynku odpornego na grzyby i korozję biologiczną";
        }
        return "Tynk odporny na grzyby i korozję biologiczną";
      }
        case PlasterType.OdpornyNaZabrudzenia:
          if (args == 1) {
            return "Tynku odpornego na zabrudzenia";
          }
        return "Tynk odporny na zabrudzenia";
      case PlasterType.Paroprzepuszczalny:
        if (args == 1) {
          return "Tynku paroprzepuszczalnego";
        }
        return "Tynk paroprzepuszczalny";
    }
  }

}
